// Internalizado de @mandae/ng-api 2.13.7 na remoção da dependência.
import { Pipe, PipeTransform } from '@angular/core';
import { PackageStatus } from '../models/package-status';

@Pipe({
  name: 'packageStatus'
})
export class PackageStatusPipe implements PipeTransform {

  transform(status: PackageStatus): any {
    switch (status) {
      case PackageStatus.EmProcessamento:
        return 'Em Processamento';
      case PackageStatus.AguardandoPostagem:
        return 'Aguardando postagem';
      case PackageStatus.DevolvidaParaRemetente:
        return 'Devolvida para remetente';
      case PackageStatus.EmDevolucao:
        return 'Em devolução para Mandaê';
      case PackageStatus.AguardandoRetiradaDestinatario:
        return 'Aguardando retirada';
      case PackageStatus.EmDevolucaoParaRemetente:
        return 'Em devolução para remetente';
      case PackageStatus.Devolvida:
        return 'Devolvida para Mandaê';
    }

    return status;
  }

}
